'use client';

import { c as _c } from "react/compiler-runtime";
import type { ElementType } from 'react';
import type { Components } from 'react-markdown';
import { StreamdownProvider } from '@/components/markdown/StreamdownProvider';
import type { StreamdownAnchorTransform } from '@/components/markdown/StreamdownRenderer';
import type { StreamStatus } from '@/components/tweet/summary/types';
import { TypewriterText } from '@/components/typewriter/TypewriterText';
import { cn } from '@/lib/utils';
import { useSummarizerStreamingEffect } from './useSummarizerStreamingEffect';
type SummaryStatus = StreamStatus;
interface SummarizerStreamingTextProperties {
  as?: ElementType;
  className?: string;
  components?: Components;
  enablePreviews?: boolean;
  markdown?: boolean;
  status: SummaryStatus;
  text: string;
  transformAnchor?: StreamdownAnchorTransform;
  wrapperClassName?: string;
}
export function SummarizerStreamingText(t0) {
  const $ = _c(32);
  const {
    text,
    status,
    as: t1,
    className,
    wrapperClassName,
    markdown: t2,
    components,
    transformAnchor,
    enablePreviews: t3
  } = t0;
  const as = t1 === undefined ? "p" : t1;
  const markdown = t2 === undefined ? false : t2;
  const enablePreviews = t3 === undefined ? true : t3;
  const [effect] = useSummarizerStreamingEffect();
  const showTypewriter = effect === "typewriter" && text.length > 0;
  const showCursor = status !== "error";
  if (!text) {
    return null;
  }
  if (!markdown) {
    const Tag = as ?? "p";
    if (!showTypewriter) {
      let t4;
      if ($[0] !== Tag || $[1] !== className || $[2] !== text) {
        t4 = <Tag className={className}>{text}</Tag>;
        $[0] = Tag;
        $[1] = className;
        $[2] = text;
        $[3] = t4;
      } else {
        t4 = $[3];
      }
      return t4;
    }
    let t4;
    if ($[4] !== showCursor || $[5] !== text) {
      t4 = <TypewriterText text={text} showCursor={showCursor} />;
      $[4] = showCursor;
      $[5] = text;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== Tag || $[8] !== className || $[9] !== t4) {
      t5 = <Tag className={className}>{t4}</Tag>;
      $[7] = Tag;
      $[8] = className;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  let t4;
  if ($[11] !== wrapperClassName) {
    t4 = cn("break-words", wrapperClassName);
    $[11] = wrapperClassName;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const containerClass = t4;
  if (!showTypewriter) {
    let t5;
    if ($[13] !== className || $[14] !== components || $[15] !== enablePreviews || $[16] !== text || $[17] !== transformAnchor) {
      t5 = <StreamdownProvider className={className} components={components} transformAnchor={transformAnchor} enablePreviews={enablePreviews}>{text}</StreamdownProvider>;
      $[13] = className;
      $[14] = components;
      $[15] = enablePreviews;
      $[16] = text;
      $[17] = transformAnchor;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    const content = t5;
    let t6;
    if ($[19] !== containerClass || $[20] !== content) {
      t6 = containerClass ? <div className={containerClass}>{content}</div> : content;
      $[19] = containerClass;
      $[20] = content;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    return t6;
  }
  let t5;
  if ($[22] !== className || $[23] !== components || $[24] !== enablePreviews || $[25] !== transformAnchor) {
    t5 = t6 => {
      const {
        typed
      } = t6;
      return <StreamdownProvider className={className} components={components} transformAnchor={transformAnchor} enablePreviews={enablePreviews}>{typed}</StreamdownProvider>;
    };
    $[22] = className;
    $[23] = components;
    $[24] = enablePreviews;
    $[25] = transformAnchor;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== containerClass || $[28] !== showCursor || $[29] !== t5 || $[30] !== text) {
    t6 = <TypewriterText as="div" className={containerClass} text={text} showCursor={showCursor} renderContent={t5} />;
    $[27] = containerClass;
    $[28] = showCursor;
    $[29] = t5;
    $[30] = text;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  return t6;
}